import React from 'react'
import styled from 'styled-components'
import { ReactComponent as DiscordIco } from 'assets/svg/discord-ico.svg'
import { ReactComponent as FacebookIco } from 'assets/svg/facebook-ico.svg'
import { ReactComponent as TwitterIco } from 'assets/svg/twitter-ico.svg'
import Flex from 'elements/Flex'

interface Props {
  isDrawerOpen?: boolean
}

const StyledSocialWrapper = styled.a<{ isDrawerOpen: boolean | undefined }>`
  align-items: center;
  background-color: #2d3036;
  background-color: #2e3136;
  border-radius: 100%;
  cursor: pointer;
  display: flex;
  margin-bottom: 8px;
  margin-right: 16px;
  ${({ isDrawerOpen }) =>
    isDrawerOpen !== undefined &&
    !isDrawerOpen &&
    `margin-bottom: 8px;
  margin-right: 0px;`}
  transition: ${({ theme }) => theme.TRANSITION.fast};
  svg {
    margin: 6px;
  }
  &:hover {
    svg {
      path {
        fill: #cecece;
      }
    }
  }
`

const Social = (props: Props) => {
  const { isDrawerOpen } = props
  return (
    <Flex style={{ flexDirection: isDrawerOpen === undefined ? 'row' : isDrawerOpen ? 'row' : 'column' }}>
      <StyledSocialWrapper isDrawerOpen={isDrawerOpen} href="https://facebook.com/boxyguild" target="_blank">
        <FacebookIco />
      </StyledSocialWrapper>
      <StyledSocialWrapper isDrawerOpen={isDrawerOpen} href="https://twitter.com/boxyguild" target="_blank">
        <TwitterIco />
      </StyledSocialWrapper>
      <StyledSocialWrapper isDrawerOpen={isDrawerOpen} href="https://discord.gg/boxy" target="_blank">
        <DiscordIco />
      </StyledSocialWrapper>
    </Flex>
  )
}

export default Social
